export const ORTTO_MERGE_FIELD_ID = 'str:cm:userid';

export const buildOrttoTrackingPayload = ({ email, userId } = {}) => {
	const payload = { v: 0, fs: 1 };

	if (email) {
		payload.email = email;
	}

	if (userId) {
		payload.ei = userId.toString();
		payload.ac = [
			{
				fi: ORTTO_MERGE_FIELD_ID,
				v: userId.toString(),
			},
		];
	}

	return payload;
};
